<template>
  <div id="setpwd">
    <headerbom :hdtitle="'修改密码'"></headerbom>
    <div class="right">
      <h1>重置密码</h1>
      <section>
        <i class="iconfont iconmima"></i>
        <input type="password" v-model="pass" placeholder="请输入您的新密码">
      </section>
      <section>
        <i class="iconfont iconmima"></i>
        <input type="password" v-model="pass2" placeholder="请再次输入新密码" @keyup.enter="btnsubmit">
      </section>
      <div @click="btnsubmit">提交</div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  beforeRouteEnter(to, from, next) {
    let isrouter = false;
    if (!from.query || !from.query.uid || !from.query.key) {
      isrouter = true;
    }
    next((vm) => {
      if (isrouter) {
        vm.$router.push("/home");
      }
    });
  },
  data() {
    return {
      pass: "",
      pass2: "",
      uid: "",
      key: "",
    };
  },
  computed: {},
  components: {},
  created() {
    this.uid = this.$route.query.uid;
    this.key = this.$route.query.key;
  },
  destroyed() {},
  mounted() {},
  methods: {
    btnsubmit() {
      if (!this.pass) {
        this.$warningBox("请输入新密码");
        return;
      }
      if (!this.pass2) {
        this.$warningBox("请输入确认密码");
        return;
      }
      if (this.pass != this.pass2) {
        this.$warningBox("两次密码不一致");
        return;
      }
      var formdata = new FormData();
      formdata.append("isapi", "true");
      formdata.append("data[User][password]", this.pass);
      formdata.append("data[User][password2]", this.pass2);
      this.$https
        .post(
          this.$axiosurl +
            "/setpwd-" +
            this.uid +
            "-" +
            this.key +
            "?uid=" +
            this.uid +
            "&key=" +
            this.key,
          formdata
        )
        .then((res) => {
          if (res.indexOf("修改成功") != -1) {
            this.$warningBox("密码修改成功");
            setTimeout(() => {
              this.$router.push("/home");
            }, 2000);
          }
          if (res.indexOf("必须一致") != -1) {
            this.$warningBox("两次输入密码必须一致");
          }
          if (res.indexOf("已失效") != -1) {
            this.$warningBox("密码重置链接已失效（24小时）");
          }
          if (res.indexOf("非法访问") != -1) {
            this.$warningBox("无效链接");
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
#setpwd {
  box-sizing: border-box;
  padding-top: 1rem;
  height: 13.72rem;
  background: url("../img/aso1.png") no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .right {
    width: 5rem;
    height: 3.8rem;
    background: #fff;
    border-radius: 0.12rem;
    box-sizing: border-box;
    box-shadow: 0 0 0.12rem rgba(0, 0, 0, 0.3);
    padding: 0 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2rem auto;
    h1 {
      font-size: 0.3rem;
      color: #333;
      margin: 0.3rem 0 0.2rem;
    }
    h2 {
      font-size: 0.18rem;
      color: #666;
      line-height: 0.4rem;
      width: 100%;
      margin: 0.2rem 0;
      b {
        font-size: 0.18rem;
        margin: 0 0.03rem;
        color: #ff6e01;
      }
    }
    span {
      display: block;
      text-align: left;
      color: #999;
      cursor: pointer;
      //width: 1.4rem;
      font-size: 0.18rem;
      &:hover {
        color: #108ee9;
      }
    }
    p {
      width: 100%;
      color: #999;
      font-size: 0.18rem;
      &.oldpass {
        display: flex;
        justify-content: center;
        text-align: center;
        margin-top: 0.2rem;
        span {
          color: #108ee9;
          font-size: 0.18rem;
        }
      }
    }
    section {
      width: 100%;
      height: 0.44rem;
      border-bottom: 0.01rem solid #d3dede;
      position: relative;
      margin-bottom: 0.2rem;
      &.codeinput {
        input {
          width: 1.6rem;
        }
        img {
          width: 1rem;
          height: 0.36rem;
          position: absolute;
          left: 1.7rem;
          top: 0;
        }
        span {
          position: absolute;
          right: 0.24rem;
          top: 0.1rem;
          cursor: pointer;
          color: #108ee9;
          display: block;
          white-space: nowrap;
          font-size: 0.12rem;
          text-align: right;
        }
      }
    }
    i {
      position: absolute;
      left: 0.04rem;
      color: #666;
      z-index: 1;
      top: 50%;
      font-size: 0.16rem;
      transform: translateY(-50%);
    }
    input {
      width: 4.2rem;
      position: absolute;
      height: 0.44rem;
      left: 0;
      right: 0;
      border: none;
      box-sizing: border-box;
      padding-left: 0.31rem;
      font-size: 0.14rem;
      &::-webkit-input-placeholder {
        color: #999;
      }
    }
    div {
      width: 100%;
      height: 0.6rem;
      background: #108ee9;
      text-align: center;
      line-height: 0.6rem;
      color: #fff;
      cursor: pointer;
      border-radius: 0.06rem;
      margin-top: 0.3rem;
      font-size: 0.18rem;
      letter-spacing: 0.04rem;
      &:hover {
        background: #0a92f5;
      }
    }
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/aso/setpwd.vue